export type PresetAttributes = {
  slug?: string;
  category?: string;
  /**
   * Identifier shared by every file a multi-output run produced, absent for a
   * single-output one. This is how the creations grid regroups a run after a
   * reload — see `createGenerationRun`.
   */
  run?: string;
};

/**
 * Reads the fields packed into a Drive file's single `category` attribute.
 *
 * Several values share one key because the backend drops a generation from
 * Drive when `driveOptions.attributes` carries more than one — see
 * "Drive attributes workaround" in `docs/reference/api.md`. Each field is
 * matched independently and terminated by a comma, so adding one cannot
 * disturb the others, and a string written before a field existed still parses.
 */
const parsePresetAttributes = (input?: string): PresetAttributes => {
  if (!input) return {};
  return {
    slug: input.match(/\bslug:\s*([^,]+)/)?.[1]?.trim(),
    category: input.match(/\bcategory:\s*([^,]+)/)?.[1]?.trim(),
    run: input.match(/\brun:\s*([^,]+)/)?.[1]?.trim(),
  };
};

export default parsePresetAttributes;
